<template>
  <div class="table">
    <div class="thead">
      <div class="th">时间</div>
      <div class="th">交易类型</div>
      <div class="th">金额</div>
      <!-- <div class="th">余额</div> -->
      <div class="th">充值方式</div>
      <div class="th">单号</div>
    </div>
    <div class="tbody" v-for="(item,i) in List" :key="i">
      <div class="td">{{  item.createtime | timeform(true)}}</div>
      <div class="td">{{  item.ststus}}</div>
      <div class="td">
        <b v-if="item.ststus == '充值'" class="green">+¥{{ item.total_price }}</b>
        <b v-else class="red">-¥{{ item.total_price }}</b>
      </div>
      <!-- <div class="td">
        <b>￥{{item.yue}}</b>
      </div> -->
      <div class="td">{{ item.pay_type }}</div>
      <div class="td">{{  item.ordernum}}</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        List:[]
      }
    },
    computed:{
      ...mapState(['vipuser'])
    },
    created() {
      this.getChongZhiList()
    },
    methods: {
      //获取充值记录列表
      getChongZhiList(){
        this.$http.post('api/store/storeuser/userrecharge',{
          user_id:this.vipuser.id
        }).then(res =>{
          this.List = res.data.data
        })
      }
    }
  };

</script>
<style lang="less" scoped>
  .table {

    .thead,
    .tbody {
      display: flex;
      justify-content: space-around;
      text-align: center;
      line-height: 40px;

      .th,
      .td {
        width: 16%;
        font-size: 12px;

        &:nth-child(1) {
          width: 22%;
        }

        &:nth-child(2),
        &:nth-child(5) {
          width: 14%;
        }

        &:nth-child(3),
        &:nth-child(4) {
          width: 15%;
        }

        &:nth-child(6) {
          width: 20%;
        }
      }
    }

    .thead {
      background-color: #f5f5f5;
      border: 1px solid #e9e9e9;
      margin-bottom: 15px;
    }

    .tbody {
      line-height: 50px;
      background-color: #fff;
      border: 1px solid #e9e9e9;
      margin-bottom: 15px;

      .green {
        color: #2ec478;
      }

      .red {
        color: #f56c6c;
      }
    }
  }

</style>
